/*
 * Generated from ZapfDingbats.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1988, 1989, 1997 Adobe Systems Incorporated. All Rights Reserved.ITC Zapf Dingbats is a registered trademark of International Typeface Corporation.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
export default {
  name: 'ZapfDingbats',
  bbox: [-1, -143, 981, 820],
  ascender: 0,
  descender: 0,
  xHeight: 0,
  capHeight: 0,
  glyphNames: 'space',
  glyphWidths: [278],
  kernPairs: [],
};
